import api from "../../../api";
import {typedQuery} from "../../typing";

export const assets = typedQuery(["tprm", "assets"], async () => {
  return await api.tprm.assets.list();
});
